import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { MedicalFeeService } from 'src/app/services/medical-fee/medical-fee.service';
import { MedicalFeePeriodFilter } from '../../../model/medical-fee/medical-fee-period-filter';


@Component({
  selector: 'app-medical-fee-filter',
  templateUrl: './medical-fee-filter.component.html',
  styleUrls: ['./medical-fee-filter.component.css']
})
export class MedicalFeeFilterComponent  implements IFilterComponent, OnInit {

  viewMyStudies: boolean;
  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  medicalFeePeriodFilters: MedicalFeePeriodFilter[] = [];

  constructor(private formBuilder: FormBuilder
    , private authService: AuthService
    , private medicalFeeService: MedicalFeeService
    , private notificationToastService: NotificationToastService
    , private filterRecordService: FilterRecordService) {

    this.viewMyStudies = false;

    this.form = this.formBuilder.group({
      medicalFeePeriodFilter: ['']
    });
  }

  get f() { return this.form.controls; }

  ngOnInit(): void {
    this.medicalFeeService.getMedicalFeePeriodFilters().then((info) => {
      this.medicalFeePeriodFilters = info;
    });
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push('medicalFeePeriodFilter');
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('MedicalFeeFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('MedicalFeeFilterComponent', this.form);
  }

  async search(): Promise<any> {

    try {

        if (!this.form.controls.medicalFeePeriodFilter.value) {
          this.notificationToastService.error('Debe ingresar el período', 'Honorarios')
          return null;
        } else {
          const physicianId = Number(this.authService.getPhysicianId());
          return await this.medicalFeeService.getMedicalFeeSearchItems(
            physicianId,
            this.form.controls.medicalFeePeriodFilter.value ? this.form.controls.medicalFeePeriodFilter.value.Id : null);
        }
      } catch ( err ) {
        this.notificationToastService.error(JSON.stringify( err.error ), 'Honorarios');
      }
  }
}
